export default __webpack_public_path__ + "static/4-1e9e42469c81613a721b9eed43f43ac0.png";